<div class="popover" [nbSpinner]="loading()">
  <nb-icon icon="people-outline" pack="eva"></nb-icon>
  <div class="description">
    <div class="title">
      {{team()?.name}} (<span [ngStyle]="{color: team()?.color}">{{team()?.abbreviation}}</span>)
    </div>
    <div class="subtitle">{{team()?.leader?.firstName}} {{team()?.leader?.lastName}} / {{team()?.userCount}} Mitglieder / {{team()?.buildingCount}} Gebäude</div>
  </div>
  <button nbButton size="small" (click)="navigateToDetail()" *ngIf="!disableLink">
    <nb-icon icon="external-link" pack="eva"></nb-icon>
  </button>
</div>

